import { ResourceKey, TFunction } from "i18next";
import React from "react";

/** Ids for different types of customization table columns. */
export const columnIds = {
    name: 'Name',
    color: 'Color',
    operation: 'Operation',
    isIncluded: 'Enabled',
    includedModels: 'Covered in models',
    excludedModels: 'Different in models',
    customization: 'Customization',
    targetFile: 'Target file',
    interpretedType: 'Interpreted type',
    fmaCodeValue: 'Code Value',
    fmaCodeMeaning: 'Code Meaning',
    fmaCodeSchemeDesignator: 'Code Scheme Designator',
};

/** Localization keys for customization table column headers. */
export const columnLangKeys: { [columnId: string]: ResourceKey } = {
    [columnIds.name]: 'column.name',
    [columnIds.color]: 'column.color',
    [columnIds.operation]: 'column.operation',
    [columnIds.isIncluded]: 'column.isIncluded',
    [columnIds.includedModels]: 'column.includedModels',
    [columnIds.excludedModels]: 'column.excludedModels',
    [columnIds.customization]: 'column.customization',
    [columnIds.targetFile]: 'column.targetFile',
    [columnIds.interpretedType]: 'column.interpretedType',
    [columnIds.fmaCodeValue]: 'column.fmaCodeValue',
    [columnIds.fmaCodeMeaning]: 'column.fmaCodeMeaning',
    [columnIds.fmaCodeSchemeDesignator]: 'column.fmaCodeSchemeDesignator',
}

/** Styling names for customization table columns. */
export const columnCssNames = {
    modified: 'column-modified',
    name: 'column-name',
    color: 'column-color',
    operation: 'column-operation',
    isIncluded: 'column-is-enabled',
    interpretedType: 'column-interpreted-type',
    fmaCodeValue: 'column-code-value',
    fmaCodeMeaning: 'column-code-meaning',
    fmaCodeSchemeDesignator: 'column-code-scheme-designator',
    includedModels: 'column-included-models',
    excludedModels: 'column-excluded-models',
}

export const columnTooltips = {
    [columnIds.operation]: (t: TFunction, url?: string) => (<span>{t('column.operation.tooltip')}{url && (<span className="tooltip-url">. {t('column.operation.tooltipLink')} <a href={url} rel="noopener noreferrer" target="_blank">{t('column.operation.tooltipLinkText')}</a></span>)}</span>),
    [columnIds.isIncluded]: (t: TFunction) => (<span>{t('column.isIncluded.tooltip')}</span>),
    [columnIds.includedModels]: (t: TFunction) => (<span>{t('column.includedModels.tooltip')}</span>),
    [columnIds.excludedModels]: (t: TFunction) => (<span>{t('column.excludedModels.tooltip')}</span>),
    [columnIds.fmaCodeValue]: (t: TFunction, url?: string) => (<span>{t('column.fmaCodeValue.tooltip')}{url && (<span className="tooltip-url"> {t('column.fmaCodeValue.tooltipLink')} <a href={url} rel="noopener noreferrer" target="_blank">{url}</a></span>)}</span>),
}

export type RoiTableColumnKey = keyof typeof columnIds;
